export default "__VITE_ASSET__COGYRu1D__"